module.exports = __webpack_public_path__ + "img/stream-offline.e3eb162b.svg";